import { Query } from '../../../hooks/queries'
import { useContrastQuery } from '../../../hooks/use-contrast-query'
import { ThisConnector } from '../../../api/connector'
import { AgentSessionType } from './types'

interface Args {
  organizationUuid: string
  applicationUuid: string
  metadata: {
    label: string
    values: string[]
  }[]
}

interface Response {
  agentSessions: AgentSessionType[]
}

// eslint-disable-next-line @typescript-eslint/require-await
async function query(
  this: ThisConnector,
  { organizationUuid, applicationUuid, metadata }
) {
  return this.connector.post(
    `/organizations/${organizationUuid}/applications/${applicationUuid}/agent-sessions/filter`,
    { metadata }
  )
}

export const useAgentSessionsFilter = ({
  organizationUuid,
  applicationUuid,
  metadata
}: Args) => {
  const { isLoading, error, data } = useContrastQuery<Args, Response>(
    [Query.AGENT_SESSIONS_FILTER, organizationUuid, applicationUuid, metadata],
    query,
    {
      organizationUuid,
      applicationUuid,
      metadata
    },
    {
      enabled: !!metadata?.length
    }
  )

  return {
    isLoading,
    error,
    data
  }
}
